<template>
  <a :href="getUrl(post.slug)" class="h-full flex flex-col">
    <div class="w-full aspect-w-16 aspect-h-9 bg-grey mb-5">
      <img
        v-if="post.thumbnail"
        :srcset="
          `${post.thumbnail.urls.post_thumbnail} 1x,
          ${post.thumbnail.urls.post_thumbnail_2x} 2x`
        "
        :src="post.thumbnail.urls.post_thumbnail"
        :alt="altText"
      />
    </div>
    <p class="flex-grow w-full mb-5 text-2xl tracking-tight">{{ post.title }}</p>
    <hr
      class="block w-full py-px mx-auto mb-5 bg-gradient-to-r from-burgundy-light to-coral border-0"
    />
    <div v-if="post.author" class="flex items-center">
      <div class="w-7 mr-3" v-if="post.author.avatar">
        <div class="aspect-w-1 aspect-h-1">
          <!-- <img :src="post.author.avatar.urls.author_thumbnail" :alt="avatarAltText" /> -->
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve" class="w-full h-auto">
              <defs>
                  <clipPath :id="`${avatarId}_clip`">
                      <polygon :points="coords"/>
                  </clipPath>
              </defs>
              <foreignObject x="0" y="0" width="40" height="40" requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility" :clip-path="`url(#${avatarId}_clip)`">
                  <img
                      :src="post.author.avatar.urls.author_thumbnail"
                      :alt="avatarAltText"
                      width="100%"
                      height="100%">
              </foreignObject>
              <polygon fill="none" stroke="#3e3e3e" stroke-alignment="outer" vector-effect="non-scaling-stroke" stroke-width="2" :points="coords"/>
          </svg>
        </div>
      </div>
      <p class="text-xs tracking-tight">{{ post.author.name }}</p>
    </div>
  </a>
</template>

<script>
import Route from '../src/Route';
import get from 'lodash/get';

export default {
  props: {
    post: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      avatarId: '',
      coords: '1,1 1,30 28,30 39,39 39,1 ',
    };
  },

  computed: {
    altText() {
      return get(this.post, 'thumbnail.alt_text');
    },
    avatarAltText() {
      return get(this.post, 'author.avatar.alt_text');
    },
  },

  created() {
    this.avatarId = Math.random().toString(36).substring(7);
  },

  methods: {
    getUrl(slug) {
      return Route('posts.show', { post: slug });
    },
  },
};
</script>
